import React from "react";
import styled from "styled-components";
import { CarouselSlidesProvider, useCarouselContext, useCarouselViewportContext } from "../context";
const cx = (...classNames) => classNames.filter(Boolean).join(" ");
const _CarouselSlides = ({ children, className }) => {
    useCarouselViewportContext("CarouselSlides");
    const { state } = useCarouselContext("CarouselSlides");
    const { carouselId, axis } = state;
    return (React.createElement("ol", { "aria-live": "polite", role: "group", className: cx(className, axis === "x" ? "horizontal" : "vertical"), "data-testid": "slides-container" },
        React.createElement(CarouselSlidesProvider, { value: {} }, React.Children.map(children, (child, index) => {
            return React.cloneElement(child, {
                "data-slide-index": index,
                index,
                id: `${carouselId}-slide-${index}`,
            });
        }))));
};
export const CarouselSlides = styled(_CarouselSlides) `
  &.horizontal {
    display: flex;
    height: 100%;
  }
  &.vertical {
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;
  }
`;
//# sourceMappingURL=CarouselSlides.js.map